import React, { memo } from 'react';
import { Space, Tooltip, Typography } from 'antd';
import { ConnectorDataT } from '@/types';
import { If } from '@/components';

type Props = {
  title: string;
  connectorData: ConnectorDataT;
  archived: boolean;
};

const ConnectorTitle = memo<Props>(({ connectorData, title, archived }) => {
  if (connectorData?.sheetUrl) {
    return (
      <Tooltip title="Open Document">
        <Space>
          <Typography.Text
            onClick={(e) => {
              e?.preventDefault();
              window.open(connectorData.sheetUrl);
            }}
            style={{ color: 'var(--arya-primary-color)', cursor: 'pointer' }}
          >
            {title}
          </Typography.Text>
          <If condition={archived}>
            <Typography.Text type="danger">(archived)</Typography.Text>
          </If>
        </Space>
      </Tooltip>
    );
  }
  return (
    <Space>
      <Typography.Text>{title}</Typography.Text>
      <If condition={archived}>
        <Typography.Text type="danger">(archived)</Typography.Text>
      </If>
    </Space>
  );
});

export default ConnectorTitle;
